/*
  Marquee loop — keeps an infinite logo strip seamless at any width.

  The CSS animation moves the track by -50%. That only loops cleanly when
  each half of the track is at least as wide as the visible strip; with few
  logos on a wide screen the half is shorter and an empty gap scrolls in
  before the loop jumps back. This script repeats the set until one half
  covers the strip, and rebuilds when the strip or the set changes size
  (window resize, lazy-loaded logos arriving).

  Speed: --marquee-speed is the time to travel REFERENCE_DISTANCE px, so
  the strip moves at the same px/s whatever the number or width of logos.
  --marquee-scale converts it into the loop's real distance (one half of the
  track = reps × set width). 768 px is the width of the original six-logo
  strip, which keeps the speed the strip was tuned with.
*/
(function () {
  const REFERENCE_DISTANCE = 768;

  function build(marquee) {
    const track = marquee.querySelector('.marquee-loop__track');
    const set = track && track.querySelector('.marquee-loop__set:not([data-marquee-clone])');
    if (!set) return;

    const setWidth = set.getBoundingClientRect().width;
    if (!setWidth) return;

    const reps = Math.max(1, Math.ceil(marquee.clientWidth / setWidth));
    marquee.style.setProperty('--marquee-scale', ((reps * setWidth) / REFERENCE_DISTANCE).toFixed(3));

    const wanted = reps * 2 - 1;
    const clones = track.querySelectorAll('[data-marquee-clone]');
    if (clones.length === wanted) return;

    clones.forEach((clone) => clone.remove());
    for (let i = 0; i < wanted; i++) {
      const clone = set.cloneNode(true);
      clone.setAttribute('data-marquee-clone', '');
      // Clones are visual repeats: hidden from assistive tech and out of the
      // tab order (they still answer mouse and touch). List semantics, ids
      // references and theme editor block hooks stay on the original set.
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      clone.removeAttribute('aria-label');
      clone.querySelectorAll('[role="listitem"]').forEach((el) => el.removeAttribute('role'));
      clone.querySelectorAll('a, button').forEach((el) => {
        el.setAttribute('tabindex', '-1');
        el.removeAttribute('aria-pressed');
        el.removeAttribute('aria-describedby');
      });
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
      track.appendChild(clone);
    }
  }

  function init(marquee) {
    if (marquee.dataset.marqueeReady) return;
    marquee.dataset.marqueeReady = 'true';

    let frame = null;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        build(marquee);
      });
    };

    const set = marquee.querySelector('.marquee-loop__set:not([data-marquee-clone])');
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(marquee);
      if (set) observer.observe(set);
    } else {
      window.addEventListener('resize', schedule);
    }
    schedule();
  }

  function initAll() {
    document.querySelectorAll('.marquee-loop').forEach(init);
  }

  initAll();
  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', initAll);
})();
